import React, { useState } from "react";
import axios from "axios";
import styles from "./AllUsersTicketHistoryTable.module.css";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CallIcon from "@mui/icons-material/Call";
import { toast } from "react-hot-toast";

import { axiosConfig } from "../../../../axios/axiosConfig";
import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import PaginationControls from "../../../Pagination/PaginationControls";
import TicketDetailsModal from "../../../../pages/models/TicketDetailsModal ";

const titleOptions = [
  { label: "App Related Issue", value: "App Related Issue" },
  { label: "Payment Related Issue", value: "Payment Related Issue" },
  { label: "Alerts and Notifications", value: "Alerts and Notifications" },
  { label: "How to Create Watchlist", value: "How to Create Watchlist" },
  { label: "Talk to Customer Support", value: "Talk to Customer Support" },
  { label: "App Lock Issue", value: "App Lock Issue" },
  { label: "Others", value: "Others" },
];

const statusOptions = [
  { label: "All", value: "" },
  { label: "Open", value: "open" },
  { label: "Closed", value: "Closed" },
  { label: "InProgress", value: "InProgress" },
  { label: "Deferred", value: "Deferred" },
];

const AllUsersTicketHistoryTable = ({
  title = "",
  userType,
  // userTickets = [],
  // setAllUsersTicketsList,
}) => {
  const navigate = useNavigate();

  const [allUsersTicketsList, setAllUsersTicketsList] = useState([]);
  const [selectedIssueType, setSelectedIssueType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openTicketsCount = allUsersTicketsList.filter(
    (ticket) => ticket.status.toLowerCase() === "open"
  ).length;
  const closedTicketsCount = allUsersTicketsList.filter(
    (ticket) => ticket.status.toLowerCase() === "closed"
  ).length;

  const InProgress = allUsersTicketsList.filter(
    (ticket) => ticket.status.toLowerCase() === "inprogress"
  ).length;

  const Deferred = allUsersTicketsList.filter(
    (ticket) => ticket.status.toLowerCase() === "deferred"
  ).length;

  //  click to call handler
  const handleClickToCall = async (phoneNumber) => {
    const payload = {
      key: "460a13fa8c144cb983ea3a3fbff5247d",
      ToMobileNo: phoneNumber,
      IsLeadCreated: true,
      SourceName: "Testing",
      UserLogin: "Stockyari470587",
    };
    try {
      const response = await axios.post(
        "https://services.kit19.com/api/ClickToCall",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Call initiated successfully!");
    } catch (error) {
      toast.error("Failed to initiate call.");
    }
  };

  // FETCHING all user tickets raised
  const allUserTicketsQuery = useQuery({
    queryKey: ["all-users-tickets", page],
    // enabled: false,
    refetchOnWindowFocus: false,
    queryFn: () => fetchAllUsersTickets(page),
    onSuccess: (data) => {
      setAllUsersTicketsList(data?.results?.response);
      setTotalCount(data.count);
    },
    onError: (error) => {
      console.log("fetch Symbols error: ", error);
    },
  });

  const { isLoading } = allUserTicketsQuery;

  // post comment on user ticket
  const deleteCommentMutation = useMutation({
    mutationFn: (variables) => deleteTicket(variables),
    onSuccess: (data, variables) => {
      const { ticket_id } = variables;

      setAllUsersTicketsList((prevState) => {
        return prevState.filter((item) => item.id !== ticket_id);
      });

      window.alert(data.response);
    },
    onError: (error) => {
      console.log("del comment error: ", error);
    },
    onSettled: (data) => {},
  });

  const handleDeleteComment = (ticket_id) => {
    deleteCommentMutation.mutate({ ticket_id });
  };

  // open modals
  const handleOpenModal = (ticket) => {
    setSelectedTicket(ticket);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedTicket(null);
  };

  return (
    <div className={styles.mainContainer}>
      <h1 className="topHeadingUnderline">{title}</h1>
      {/* Display counts */}

      <Box
        sx={{
          mt: "2rem",
          mb: "2rem",
          px: "1.5rem",
          py: "1rem",
          borderRadius: "10px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
          backgroundColor: "#f5f5f5", // light gray background
          maxWidth: "1500px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          rowGap: 2,
        }}
      >
        <Stack direction="row" spacing={3} alignItems="center" flexWrap="wrap">
          <Typography variant="h5" fontWeight="bold" sx={{ color: "#333" }}>
            Users Ticket History
          </Typography>
          <FormControl sx={{ minWidth: 250, mb: 1 }}>
            <InputLabel id="issue-type-label">Filter by Issue Type</InputLabel>
            <Select
              labelId="issue-type-label"
              id="issue-type-select"
              value={selectedIssueType}
              label="Issue Type"
              onChange={(e) => setSelectedIssueType(e.target.value)}
            >
              <MenuItem value="">All Issue Types</MenuItem>
              {titleOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>

        <Box sx={{ textAlign: "right", minWidth: 200 }}>
          <Typography variant="body1">
            <strong>Open Tickets:</strong>
            <span style={{ color: "#4f66c0", fontWeight: 500 }}>
              {openTicketsCount}
            </span>
          </Typography>
          <Typography variant="body1">
            <strong>Closed Tickets:</strong>
            <span style={{ color: "#ec007c", fontWeight: 500 }}>
              {closedTicketsCount}
            </span>
          </Typography>
          <Typography variant="body1">
            <strong>InProgress Tickets:</strong>
            <span style={{ color: "#ec007c", fontWeight: 500 }}>
              {InProgress}
            </span>
          </Typography>
          <Typography variant="body1">
            <strong>Deferred Tickets:</strong>
            <span style={{ color: "#ec007c", fontWeight: 500 }}>
              {Deferred}
            </span>
          </Typography>
        </Box>
      </Box>

      {/* all users ticket history table */}
      <table className={styles.tableContainer}>
        <thead>
          <tr>
            <th>Ticket ID</th>
            <th>Mobile</th>
            <th>User Name</th>
            <th>Title</th>
            <th>Description</th>
            <th>
              Created On
              {/* <Stack direction="column" spacing={0.5}>
                <Stack direction="row" spacing={0.5}>
                  <label>From:</label>
                  <input
                    type="date"
                    name="fromDate"
                    id="fromDate"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                  <button onClick={() => allUserTicketsQuery.refetch()}>
                    ok
                  </button>
                </Stack>

                <Stack direction="row" spacing={0.5}>
                  <label>To:</label>
                  <input
                    type="date"
                    name="toDate"
                    id="toDate"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                  <button
                    title="Clear Date Filter"
                    className={styles.html_btn}
                    disabled={!(fromDate && toDate)}
                    onClick={() => {
                      setFromDate("");
                      setToDate("");
                    }}
                  >
                    clr
                  </button>
                </Stack>
              </Stack> */}
            </th>
            <th>
              Status
              <select
                className={styles.user_Type_Select_Input}
                name="status"
                placeholder="Filter by Status"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="">Filter by status</option>
                {statusOptions.map((item, index) => (
                  <option key={item.label} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </th>
            <th>Priority</th>
            <th>Last Updated</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody className={styles.tableBodyContainer}>
          {isLoading ? (
            <tr>
              <td colSpan="10" style={{ textAlign: "center", padding: "2rem" }}>
                <CircularProgress size={30} />
                <div
                  style={{
                    marginTop: "0.5rem",
                    fontSize: "14px",
                    color: "#666",
                  }}
                >
                  Loading Tickets...
                </div>
              </td>
            </tr>
          ) : (
            allUsersTicketsList
              .filter(
                (item) =>
                  (!selectedIssueType || item.title === selectedIssueType) &&
                  (!selectedStatus || item.status === selectedStatus)
              )
              .map((item) => {
                const createdDate = new Date(item.created_at).toDateString();
                const modifiedDate = new Date(item.modified_at).toDateString();
                // const isTicketChecked = item?.isticketcheck;

                const isTicketCheckedStyles = !item?.isticketcheck
                  ? {
                      backgroundColor: "#F1BBB8",
                      fontWeight: "bold",
                      color: "#333",
                      // color: "#e2e2e2"
                    }
                  : null;

                return (
                  <tr key={item.id} style={isTicketCheckedStyles}>
                    <td>{item.ticket_id}</td>
                    <td>{item?.requester_phone}</td>
                    <td>{item.requester_name}</td>
                    <td>
                      {item.title.length > 20
                        ? `${item.title.substring(0, 20)}...`
                        : item.title}
                    </td>
                    <td>
                      {item.description.length > 30
                        ? `${item.description.substring(0, 30)}...`
                        : item.description}
                    </td>
                    <td>{createdDate}</td>
                    <td>{item.status}</td>
                    <td>{item.priority}</td>
                    <td>{modifiedDate}</td>

                    <td style={{ display: "flex" }}>
                      <div className={styles.viewBtnContainer}>
                        <button
                          style={{ marginLeft: "15px" }}
                          className={styles.viewBtn}
                          onClick={() => handleOpenModal(item)}
                          // onClick={() =>
                          //   navigate(`/${userType}/user-support/${item.id}`)
                          // }
                        >
                          <VisibilityIcon />
                        </button>

                        {/* <button>
                    <CallIcon/>
                    </button> */}

                        {/* {deleteCommentMutation.isLoading ? (
                      "..."
                    ) : (
                      <button onClick={() => handleDeleteComment(item.id)}>
                        delete
                      </button>
                    )} */}
                      </div>
                      <div style={styles.viewBtnContainer}>
                        <button
                          style={{ marginLeft: "15px" }}
                          className={styles.viewBtn}
                          onClick={() =>
                            handleClickToCall(item?.requester_phone)
                          }
                        >
                          <CallIcon />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
          )}
        </tbody>
        {isModalOpen && (
          <TicketDetailsModal
            open={isModalOpen}
            handleClose={handleCloseModal}
            ticket={selectedTicket}
            userType={userType}
          />
        )}
      </table>
      <PaginationControls
        totalCount={totalCount}
        page={page}
        setPage={setPage}
        offset={100}
      />
    </div>
  );
};

export default AllUsersTicketHistoryTable;

// UTILITY FUNCTIONS
const deleteTicket = async ({ ticket_id }) => {
  if (!ticket_id) return;

  const res = await axiosConfig({
    method: "delete",
    url: "/support/raise_request",
    data: {
      id: ticket_id,
    },
  });

  return res.data;
};

const fetchAllUsersTickets = async (page) => {
  // if (!user_id) return;

  const res = await axiosConfig({
    method: "get",
    url: `/support/raise_request?page=${page}`,
    data: {},
  });

  return res.data;
};
